import { ref } from "vue";

/** @type {import('vue').Ref<Array<{ id: number, tipo: 'ok' | 'error' | 'info', mensaje: string }>>} */
const toasts = ref([]);
let seq = 0;

export function useToast() {
  /**
   * @param {string} mensaje
   * @param {'ok' | 'error' | 'info'} [tipo]
   * @param {number} [ms]
   */
  function push(mensaje, tipo = "info", ms = 3200) {
    const id = ++seq;
    toasts.value = [...toasts.value, { id, tipo, mensaje }];
    window.setTimeout(() => {
      toasts.value = toasts.value.filter((t) => t.id !== id);
    }, ms);
  }

  function ok(mensaje) {
    push(mensaje, "ok");
  }

  function error(mensaje) {
    push(mensaje, "error", 4500);
  }

  function info(mensaje) {
    push(mensaje, "info");
  }

  function dismiss(id) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  }

  return { toasts, push, ok, error, info, dismiss };
}
